import React from 'react';
function Feil () {
    return <p>Feil i URL</p>
}
export default Feil;